module.exports = __webpack_public_path__ + "static/ms-094ad248ee4651adb3e4155925f5220d.svg";